import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import ReactSVG from 'react-svg'
import classNames from 'classnames'

import styles from './my-list-button.css'
import CONTENT_ITEM_LIGHT_FRAGMENT from '../../../../graphql/fragments/content-item-light.gql'

import AddMyListAdd from '../../../../images/add-my-list-add.svg'
import Button from '../../button'

const MyListButton = ({
  contentItem, isOnMyList, addAction, className, isRental, deleteFromMyList,
  isBigIcon, inOnboardingRecommendation
}) => {
  const onClick = (event) => {
    event.preventDefault()
    event.stopPropagation()

    return addAction(contentItem)
  }

  return (
    <Button
      className={classNames(className, styles.myListButton, {
        [styles.bigIcon]: isBigIcon
      })}
      e2eIdentifier={inOnboardingRecommendation ? `Onboarding-recommendation-${contentItem.path}` : `my-list-button-${contentItem.path}`}
      isRental={isRental}
      onClick={(deleteFromMyList || inOnboardingRecommendation) ? null : onClick}
      darkBGSecondary
    >
      <ReactSVG
        src={AddMyListAdd}
        beforeInjection={(svg) => {
          svg.setAttribute('class', classNames(styles.iconOnHoverStyle, {
            [styles.iconOnHoverRentalStyle]: isRental,
            [styles.inOnboardingRecommendation]: inOnboardingRecommendation
          }))
        }}
      />
    </Button>
  )
}

MyListButton.propTypes = {
  contentItem: propType(CONTENT_ITEM_LIGHT_FRAGMENT).isRequired,
  addAction: PropTypes.func,
  isOnMyList: PropTypes.bool,
  className: PropTypes.string,
  isRental: PropTypes.bool,
  deleteFromMyList: PropTypes.bool,
  isBigIcon: PropTypes.bool,
  inOnboardingRecommendation: PropTypes.bool
}

MyListButton.defaultProps = {
  className: '',
  isOnMyList: false,
  isRental: false,
  isBigIcon: false,
  deleteFromMyList: false,
  inOnboardingRecommendation: false,
  addAction: () => {}
}

export default MyListButton
